import { Box } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import EditorIframe from './EditorIframe';

import * as styles from './DonationFormBuilder.css';

function Content(): JSX.Element {
  return (
    <Box className={styles.root}>
      <EditorIframe />
    </Box>
  );
}

export default observer(Content);
